import React, { useEffect, useState } from 'react';
import CourseImportPopup from '../certificationPopup/CourseImportPopup';
import CourseDeletePopup from '../certificationPopup/CourseDeletePopup';
import { applyForCertification, fetchCertificationDetails, fetchCourseDetails, getCertificationCount, getDomain, importcoursedetails, postCourse } from '../../service/certificationAPI';
import CertificationList from './CertificationsList';
import EmployeeCertifications from './EmployeeCertification';
import PracticeMultiSelect from '../certificationPopup/PracticeMultiSelect';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import MyCertifications from './MyCertifications';
import { encryptStorage } from '../../constant';
import ApplyCertificationPopup from '../certificationPopup/ApplyCertification';
import { Toaster } from '../SoftSkills/Toast';
import DOMPurify from 'dompurify';
import { getS3 } from "../../utils/Download";

//SQ- 1.3- 1.24 :Initialize the required state variables.
const AdminCertifications = () => {
    const [coursesData, setCoursesData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [numberOfRecords, setNumberOfRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filterValue, setFilterValue] = useState({
        provider: "", practice: "", cost: { from: 0, to: 0 }, limit: { from: null, to: null }, // Add this line
        createdDate: { from: "", to: "" }
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [showSuccessToast, setShowSuccessToast] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editFormData, setEditFormData] = useState({});
    const [sortColumn, setSortColumn] = useState("");
    const [sortOrder, setSortOrder] = useState();
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [certificateToDelete, setCertificateToDelete] = useState(null);
    const [certificateNameToDelete, setCertificateNameToDelete] = useState("");
    const [activeTab, setActiveTab] = useState('manageCertifications');
    const [providers, setProviders] = useState([]);
    const [domains, setDomains] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showApplyPopup, setshowApplyPopup] = useState(false);
    const [employeeName, setEmployeeName] = useState("")
    const [empDomain, setempDomain] = useState("")
    const [empId, setEmpId] = useState("")
    const [dateError, setDateError] = useState("");
    const [currentnumberofRecords, setCurrentnumberofRecords] = useState(0);
    const [filtersVersion, setFiltersVersion] = useState(0);
    const [certificates, setCertificates] = useState([]);
    const [roundedCtc, setRoundedCtc] = useState(0);
    const [allowedCertifications, setAllowedCertifications] = useState(0);
    const [completedCertifications, setCompletedCertifications] = useState(0);
    const [costLimit, setCostLimit] = useState(0);
    const [myCertificationsCount, setMyCertificationsCount] = useState({
        total: 0,
        current: 0
    });

    const [approvalsCount, setApprovalsCount] = useState({
        total: 0,
        current: 0
    });

    const [manageCertificationsCount, setManageCertificationsCount] = useState({
        total: 0,
        current: 0
    });

    const [materialLinkError, setMaterialLinkError] = useState(false);
    const [s3Link, sets3Link] = useState("")
    const showLoadMore = () => {
        if (activeTab === 'manageCertifications') {
            return manageCertificationsCount.total > 10 && manageCertificationsCount.current < manageCertificationsCount.total && manageCertificationsCount.current >= 10;
        } else if (activeTab === 'myCertifications') {
            return myCertificationsCount.total > 10 && myCertificationsCount.current < myCertificationsCount.total && myCertificationsCount.current >= 10;
        } else if (activeTab === 'certificationApprovals') {
            return approvalsCount.total > 10 && approvalsCount.current < approvalsCount.total && approvalsCount.current >= 10;
        }
        return false;
    };

    // Tab-specific filters
    const [employeeFilter, setEmployeeFilter] = useState({
        provider: "", createdFrom: "", createdTo: ""
    });

    // Popup states
    const [showImportPopup, setShowImportPopup] = useState(false);
    const domain = encryptStorage.getItem('domain');


    let breadCrumbData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'How Do I ?', path: '/', isActive: true },
        { title: 'Certifications', path: '/admin/certifications', isActive: false }
    ];

    const [approvalsFilter, setApprovalsFilter] = useState({
        costFrom: "",
        costTo: "",
        limitFrom: "",
        limitTo: ""
    });

    const [manageFilter, setManageFilter] = useState({
        provider: "",
        costFrom: "",
        costTo: ""
    });

    const [validationErrors, setValidationErrors] = useState({
        certificateName: false,
        provider: false,
        cost: false,
        practice: false
    });


    // SQ-1.25-1.27 Fetch courses data on component mount
    useEffect(() => {
        if (activeTab === 'manageCertifications') {
            fetchCoursesData();
        } else {
            fetchCertifications();
        }
    }, [activeTab, currentnumberofRecords, filtersVersion, sortColumn, sortOrder, searchTerm]);


    useEffect(() => {
        fetchCertifications();
        fetchDomains();
    }, [currentnumberofRecords]);

    useEffect(() => {
        setEmpId(encryptStorage.getItem('employeeId'));
        setEmployeeName(encryptStorage.getItem('employeeName'));
        setempDomain(encryptStorage.getItem('domain'));

    }, []);

    useEffect(() => {
        if (empId) {
            fetchCertificationCount();
        }
    }, [showApplyPopup, empId]);

    const fetchCertificationCount = async () => {
        try {
            const params = { emp_id: empId };
            const statsData = await getCertificationCount(params);
            setRoundedCtc(statsData.roundedCtc);
            setAllowedCertifications(statsData.allowedCertifications);
            setCompletedCertifications(statsData.completedCertifications);
            setCostLimit(statsData.costLimit);
            sets3Link(statsData.s3Link)
        } catch (error) {
            console.error("Error fetching certification count:", error);
        }
    };


    const fetchDomains = async () => {
        try {
            const response = await getDomain();
            if (response.status === "Success") {
                setDomains(response.data.map(item => item.domain));
            }
        } catch (error) {
            console.error("Error fetching domains:", error);
        }
    };

    const validateURL = (url) => {
        try {
            // Use the URL constructor to validate the URL
            new URL(url);
            // Ensure the URL has a valid scheme (http, https, etc.)
            return /^https?:\/\//i.test(url); // Enforce http or https scheme
        } catch (error) {
            return false;
        }
    };

    const handleOpenApplyCertification = () => {
        setshowApplyPopup(true);
    };
    // seq 9.21 - 9.22
    // Function to handle button click and open signed URL
    const handleS3LinkClick = async (s3Link) => {
        try {
            // Call getS3url to get the signed URL
            const signedUrlResponse = await getS3(s3Link);

            // Adjust the property name based on your actual response structure
            const signedUrl = signedUrlResponse?.signedUrl || signedUrlResponse;

            if (signedUrl) {
                // Open the signed URL in a new tab
                window.open(signedUrl, '_blank');
            } else {
                console.error('No signed URL received in response');
            }
        } catch (error) {
            console.error('Error fetching signed S3 URL:', error);
        }
    };

    const fetchCertifications = async () => {
        try {
            const params = {
                group_id: encryptStorage.getItem('groupid'),
                domain: encryptStorage.getItem('domain'),
                current_number_of_records: currentnumberofRecords,
                page_size: pageSize,
                search_term: searchTerm,
                sort_column: sortColumn,
                sort_order: sortOrder,
                "filter.provider": activeTab === 'certificationApprovals'
                    ? approvalsFilter.provider
                    : employeeFilter.provider,
                ...(activeTab !== 'certificationApprovals' && {
                    emp_id: encryptStorage.getItem('employeeId')
                }),
                "filter.cost.from": activeTab === 'certificationApprovals'
                    ? approvalsFilter.costFrom
                    : null,
                "filter.cost.to": activeTab === 'certificationApprovals'
                    ? approvalsFilter.costTo
                    : null,
                "filter.created_date.from": activeTab === 'myCertifications'
                    ? employeeFilter.createdFrom
                    : null,
                "filter.created_date.to": activeTab === 'myCertifications'
                    ? employeeFilter.createdTo
                    : null,
                'filter.limit.from': filterValue.limit.from !== null ? filterValue.limit.from : 0,
                'filter.limit.to': filterValue.limit.to !== null ? filterValue.limit.to : 0
            };


            const response = await fetchCertificationDetails(params);
            if (response.status === "success") {
                setProviders(response.data.providers || []);
                setCertificates(response.data.certificates);
                if (activeTab === 'myCertifications') {
                    setMyCertificationsCount({
                        total: response.data.meta.total_count,
                        current: response.data.meta.count
                    });
                } else if (activeTab === 'certificationApprovals') {
                    setApprovalsCount({
                        total: response.data.meta.total_count,
                        current: response.data.meta.count
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching certifications:", error);
        } finally {
        }
    };

    const handleDateChange = (name, value) => {
        setEmployeeFilter(prev => {
            const newFilter = { ...prev, [name]: value };

            // Validate dates only when both are set
            if (newFilter.createdFrom && newFilter.createdTo) {
                if (new Date(newFilter.createdFrom) > new Date(newFilter.createdTo)) {
                    setDateError("End date cannot be before start date");
                } else {
                    setDateError("");
                }
            } else {
                setDateError("");
            }

            return newFilter;
        });
    };

    const handleEmployeeFilterChange = (name, value) => {
        setEmployeeFilter(prev => ({ ...prev, [name]: value }));
    };


    // SQ - 1.28 -1.64 : Fetch courses data (this should be replaced with actual API call)
    const fetchCoursesData = async () => {
        try {
            // Convert cost filters to integers, defaulting to 0 if empty
            const costFromInt = parseInt(manageFilter.costFrom) || 0;
            const costToInt = parseInt(manageFilter.costTo) || 0;

            const payload = {
                currentnumber_of_records: currentnumberofRecords,
                page_size: pageSize,
                search_term: searchTerm,
                filter: {
                    provider: manageFilter.provider,
                    cost: {
                        from: costFromInt,
                        to: costToInt
                    }
                },
                sort_column: sortColumn,
                sort_order: sortOrder
            };
            const response = await fetchCourseDetails(payload);
            if (response.status === "success") {
                setCoursesData(response.data);
                if (activeTab === 'manageCertifications') {
                    setManageCertificationsCount({
                        total: response.meta.totalRecords,
                        current: response.meta.numberOfRecords
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching course data:", error);
            setErrorMessage("Failed to fetch course data");
        }
    };
    const getSortIcon = (column) => {
        if (sortColumn !== column) return "/Images/sort-icon.svg";
        return sortOrder === 1 ? "/Images/Sort-up.svg" : "/Images/sort-icon.svg";
    };

    //SQ 2.1- 2.20 - handle search is invoked
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    //SQ 3.1- 3.4 : The tab change is handled here.
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setCurrentnumberofRecords(0);
        setSearchTerm("");
        setSortColumn("");
        setSortOrder(-1);

        // Reset filters when tab changes
        setApprovalsFilter({
            costFrom: "",
            costTo: "",
            limitFrom: "",
            limitTo: ""
        });
        setManageFilter({
            provider: "",
            costFrom: "",
            costTo: ""
        });
        setEmployeeFilter({
            provider: "",
            createdFrom: "",
            createdTo: ""
        });
    };


    // SQ 3.5 - 3.18  Handle filter change
    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        if (name === "provider") {
            setFilterValue(prev => ({ ...prev, provider: value }));
        } else if (name === "costFrom" || name === "costTo") {
            setFilterValue(prev => ({
                ...prev,
                cost: { ...prev.cost, [name === "costFrom" ? "from" : "to"]: value }
            }));
        }
    };

    const handleApprovalsFilterChange = (event) => {
        const { name, value } = event.target;
        setApprovalsFilter(prev => ({ ...prev, [name]: value }));
    };

    const handleManageFilterChange = (event) => {
        const { name, value } = event.target;
        setManageFilter(prev => ({ ...prev, [name]: value }));
    };

    const handleApplyApprovalsFilters = () => {
        // Apply approvals filter logic
    };

    const handleApplyManageFilters = () => {
        fetchCoursesData();
    };
    const handleClearSearch = () => {
        setSearchTerm("");
        // Call fetch with empty search term and cleared filters
        handleApplyFilters(); // or directly call fetchCoursesData or fetchCertifications with updated params
    };

    const handleClearFilters = () => {
        // Reset filter states based on active tab
        switch (activeTab) {
            case 'manageCertifications':
                setManageFilter({
                    provider: "",
                    costFrom: "",
                    costTo: ""
                });
                break;
            case 'certificationApprovals':
                setApprovalsFilter({
                    costFrom: "",
                    costTo: "",
                    limitFrom: "",
                    limitTo: ""
                });
                setFilterValue(prev => ({
                    ...prev,
                    limit: { from: null, to: null }
                }));
                break;
            case 'myCertifications':
                setEmployeeFilter({
                    provider: "",
                    createdFrom: "",
                    createdTo: ""
                });
                break;
            default:
                break;
        }

        // Reset search and pagination
        setSearchTerm("");
        setCurrentPage(1);
        setNumberOfRecords(0);
        setCurrentnumberofRecords(0);
        setDateError("");

        setFiltersVersion(prev => prev + 1);
    };

    const handleShowMore = () => {
        setCurrentnumberofRecords(prev => prev + 1);

    };
    const handleApplyFilters = () => {
        // Reset pagination when applying new filters
        setCurrentPage(1);
        setNumberOfRecords(0);

        // Trigger API call based on active tab
        switch (activeTab) {
            case 'manageCertifications':
                fetchCoursesData();
                break;
            case 'certificationApprovals':
                fetchCertifications();
                break;
            case 'myCertifications':
                fetchCertifications();
                break;
            default:
                break;
        }
    };

    // SQ- 9.1 - 9.19 Handle sorting
    const handleSortChange = (column) => {
        if (sortColumn === column) {
            setSortOrder(sortOrder === 1 ? -1 : 1); // Toggle sort order
        } else {
            setSortColumn(column);
            setSortOrder(-1); // Default to descending for new column
        }
        // No need to call fetch here - useEffect will handle it
    };

    const handleClearEmployeeFilters = () => {
        setEmployeeFilter({
            provider: "",
            createdFrom: "",
            createdTo: ""
        });
        setSearchTerm("");
        setCurrentnumberofRecords(0);
        setFiltersVersion(prev => prev + 1);
    };

    // SQ 6.1 - 6.31  Handle delete click
    const handleDeleteClick = (certificateId, certificateName) => {
        setCertificateToDelete(certificateId);
        setCertificateNameToDelete(certificateName);
        setShowDeletePopup(true); // Show the delete popup
    };

    // SQ - 6. 11 - 6.13  Handle confirm delete
    const handleConfirmDelete = async () => {
        try {
            const payload = {
                action: "delete",
                certificate_id: certificateToDelete,
                certificate_name: "",
                provider: "",
                cost: "",
                practice: "",
                materials_link: ""

            };

            await postCourse(payload); // Call API to delete the course
            fetchCoursesData(); // Refresh data after deletion
            setShowSuccessToast(true);
        } catch (error) {
            setErrorMessage("Failed to delete course.");
        } finally {
            setShowDeletePopup(false); // Close the popup after operation
        }
    };

    // SQ- 7.1 - 7.18 Handle edit click
    const handleEditClick = (course) => {
        setIsEditMode(true); // Set edit mode to true
        setEditFormData({
            ...course,
            cost: course.cost.replace('$', ''), // Remove the dollar sign for editing
        });
    };

    //SQ 8.1 - 8.47 - Handles the import and upload.
    const openImportPopup = () => {
        setShowImportPopup(true);
    };

    const handleUpload = async (data) => {
        try {

            await importcoursedetails(data)
            setShowImportPopup(false); // Close the popup after uploading
            await handleClearFilters();

            // Call your fetch function to reload data
            await fetchCertifications(); // Or
        } catch (error) {
            console.error('Error importing courses:', error);

        }
    };

    // SQ- 7.3- 7.19 : Handles the addion of the courses.
    const handleAddCourse = async () => {
        const errors = {
            certificateName: !editFormData.certificateName,
            provider: !editFormData.provider,
            cost: editFormData.cost === '0' || editFormData.cost === '',
            practice: !editFormData.practice || editFormData.practice.length === 0,
            materialPath: !validateURL(editFormData.materialPath)
        };

        setValidationErrors(errors);
        setMaterialLinkError(errors.materialPath); 

        // Check if any validation errors exist
        if (Object.values(errors).some(error => error)) {
            return;
        }

        try {
            const payload = {
                certificate_id: editFormData.certificateId,
                certificate_name: editFormData.certificateName,
                provider: editFormData.provider,
                cost: editFormData.cost,
                practice: Array.isArray(editFormData.practice)
                    ? editFormData.practice.join(',')
                    : editFormData.practice,
                materials_link: editFormData.materialPath
            };
            await postCourse(payload);
            setEditFormData({
                certificateName: "",
                provider: "",
                cost: "",
                practice: [],
                materialPath: ""
            });
            setValidationErrors({
                certificateName: false,
                provider: false,
                cost: false,
                practice: false,
                 materialPath: false
            });

            await fetchCoursesData();

        } catch (error) {
            setErrorMessage("Failed to add course");
        }
    };

    const handleSubmitApplication = async (applicationData) => {
        try {
            await applyForCertification(applicationData);
            await fetchCertifications()
            setshowApplyPopup(false)

        } catch (error) {
            setErrorMessage("Failed to submit application");
        }
    };

    const renderFilterContent = () => {
        switch (activeTab) {
            case 'manageCertifications':
                return (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="provider">Provider</label>
                                <select
                                    className="form-select hive-form-select"
                                    value={manageFilter.provider}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setManageFilter({ ...manageFilter, provider: sanitizedValue });
                                    }}
                                    id="provider"
                                >
                                    <option value="">Select </option>
                                    {providers.map((provider, index) => (
                                        <option key={index} value={provider}>
                                            {provider}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="col-md-12 pb-2 border-0">
                            <span className="font-14 semibold-text filter-title">Cost</span>
                        </div>

                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="fromrange">From</label>
                                <input
                                    type="number"
                                    placeholder="Enter value"
                                    className="form-control hive-form-control"
                                    value={manageFilter.costFrom}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setManageFilter({ ...manageFilter, costFrom: sanitizedValue });
                                    }}
                                    id="fromrange"
                                />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="Torange">To</label>
                                <input
                                    type="number"
                                    placeholder="Enter value"
                                    className="form-control hive-form-control"
                                    value={manageFilter.costTo}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setManageFilter({ ...manageFilter, costTo: sanitizedValue });
                                    }}
                                    id="Torange"
                                />
                            </div>
                        </div>

                    </>
                );
            case 'certificationApprovals':
                return (
                    <>
                        <div className="col-md-6 mb-3 ">
                            <span className="font-14 semibold-text filter-title">Certification Cost</span>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="fromDate">From </label>
                                <input
                                    type="number"
                                    placeholder="From value"
                                    className="form-control hive-form-control"
                                    value={approvalsFilter.costFrom}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setApprovalsFilter({ ...approvalsFilter, costFrom: sanitizedValue });
                                    }}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="ToDate">To </label>
                                <input
                                    type="number"
                                    placeholder="To value"
                                    className="form-control hive-form-control"
                                    value={approvalsFilter.costTo}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setApprovalsFilter({ ...approvalsFilter, costTo: sanitizedValue });
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label hive-form-label">Available Limit</label>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="ToDate">From</label>

                                <input
                                    type="number"
                                    placeholder="Enter value"
                                    className="form-control"
                                    value={filterValue.limit.from === null ? "" : filterValue.limit.from}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setFilterValue(prev => ({
                                            ...prev,
                                            limit: {
                                                ...prev.limit,
                                                from: sanitizedValue === "" ? null : parseInt(sanitizedValue)
                                            }
                                        }));
                                    }}
                                    id="limitFrom"
                                />

                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="ToDate">To</label>

                                <input
                                    type="number"
                                    placeholder="Enter value"
                                    className="form-control"
                                    value={filterValue.limit.to === null ? "" : filterValue.limit.to}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setFilterValue(prev => ({
                                            ...prev,
                                            limit: {
                                                ...prev.limit,
                                                to: sanitizedValue === "" ? null : parseInt(sanitizedValue)
                                            }
                                        }));
                                    }}
                                />
                            </div>
                        </div>

                    </>
                );
            case 'myCertifications':
                return (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="provider">Provider</label>
                                <select
                                    className="form-select hive-form-select"
                                    value={employeeFilter.provider}
                                    onChange={(e) => {
                                        const sanitizedValue = DOMPurify.sanitize(e.target.value);
                                        setEmployeeFilter({ ...approvalsFilter, provider: sanitizedValue });
                                    }}
                                    id="provider"
                                >
                                    <option value="">Select</option>
                                    {providers.map((provider, index) => (
                                        <option key={index} value={provider}>
                                            {provider}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-md-12 pb-2 border-0">
                            <label className="font-14 semibold-text filter-title">Created On</label>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="fromrange">From</label>

                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    value={employeeFilter.createdFrom}
                                    onChange={(e) => handleDateChange("createdFrom", e.target.value)}
                                    id="fromrange"
                                    max={employeeFilter.createdTo || ""}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label hive-form-label" htmlFor="Torange">To</label>

                                <input
                                    type="date"
                                    className="form-control hive-form-control"
                                    value={employeeFilter.createdTo}
                                    onChange={(e) => handleDateChange("createdTo", e.target.value)}
                                    min={employeeFilter.createdFrom || ""}
                                />
                                {dateError && (
                                    <div className="text-danger font-12 mt-1">
                                        <img
                                            src="/Images/error-icon.svg"
                                            alt="error-icon"
                                            className="me-1"
                                            style={{ width: '12px', height: '12px' }}
                                        />
                                        {dateError}
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    const renderActionButton = () => {
        switch (activeTab) {
            case 'manageCertifications':
                return (
                    <button type="button" className="btn hive-btn-primary" onClick={() => setShowImportPopup(true)}>
                        <img src="/Images/import-icon.svg" className="me-2" alt="import-icon" />
                        Import
                    </button>
                );
            case 'myCertifications':
                return (
                    <button className="btn hive-btn-primary" onClick={handleOpenApplyCertification}>
                        Apply Certification
                    </button>
                );
            default:
                return null;
        }
    };
    const isFieldsEmpty = () => {
        switch (activeTab) {
            case 'manageCertifications':
                return !manageFilter.provider && !manageFilter.costFrom && !manageFilter.costTo;
            case 'certificationApprovals':
                return !approvalsFilter.costFrom && !approvalsFilter.costTo && !filterValue.limit.from && !filterValue.limit.to;
            case 'myCertifications':
                return !employeeFilter.provider && !employeeFilter.createdFrom && !employeeFilter.createdTo;
            default:
                return true;
        }
    };

    const handleInputChange = (field, value) => {
        const sanitizedValue = DOMPurify.sanitize(value);
        setEditFormData({ ...editFormData, [field]: sanitizedValue });

        if (validationErrors[field]) {
            setValidationErrors({ ...validationErrors, [field]: false });
        }
    };

    const validateCost = (value) => {
        if (value === '' || /^[0-9\s$]+$/.test(value)) {
            return true;
        }
        return false;
    };

    return (
        <div className="body-bg">
            <div className="container-fluid mt-6">
                <div className="row justify-content-center">
                    <div className="col-md-12 d-flex align-items-center">
                        <BreadCrumbs data={breadCrumbData} />
                    </div>

                    <div className="col-md-12 d-flex align-items-center ">
                        {/* Tab Structure Starts Here */}
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link rounded-0 font-12 bold-text tab-style me-4 ${activeTab === 'myCertifications' ? 'active' : ''}`}
                                    id="myCertificationsTab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#myCertifications"
                                    type="button"
                                    role="tab"
                                    aria-controls="myCertifications"
                                    aria-selected={activeTab === 'myCertifications'}
                                    onClick={() => setActiveTab('myCertifications')}
                                >
                                    My Certifications
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link rounded-0 font-12 bold-text tab-style me-4 ${activeTab === 'certificationApprovals' ? 'active' : ''}`}
                                    id="certificationApprovalsTab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#certificationApprovals"
                                    type="button"
                                    role="tab"
                                    aria-controls="certificationApprovals"
                                    aria-selected={activeTab === 'certificationApprovals'}
                                    onClick={() => setActiveTab('certificationApprovals')}
                                >
                                    Certification Approvals
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link rounded-0 font-12 bold-text tab-style me-4 ${activeTab === 'manageCertifications' ? 'active' : ''}`}
                                    id="manageCertificationsTab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#manageCertifications"
                                    type="button"
                                    role="tab"
                                    aria-controls="manageCertifications"
                                    aria-selected={activeTab === 'manageCertifications'}
                                    onClick={() => setActiveTab('manageCertifications')}
                                >
                                    Manage Certifications
                                </button>
                            </li>
                        </ul>
                        {/* Tab Structure Ends Here */}

                        <div className="ms-auto d-flex">
                            <div className="input-group flex-nowrap search-group me-3">
                                <input type="search" className="form-control search-align" placeholder="Search" aria-label="Username"
                                    value={searchTerm} onChange={handleSearchChange} />
                                <button className="input-group-text btn btn-search-custom">
                                    <img src="/Images/search-icon.svg" alt="search-icon" /></button>
                            </div>
                            {/* Filter Section Starts Here */}
                            <div className="dropdown me-3" >
                                <button
                                    className="advanced-filter-button me-2 medium-text"
                                    type="button"
                                    id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <img src="/Images/filter-icon.svg" alt="filter-icon" className="me-2" />
                                    Filter
                                </button>
                                <div className="dropdown-menu px-3 advanced-filter-panel shadow session-filter mt-5" >
                                    <div className="row">
                                        <div className="col-md-12 py-2 border-0 mb-1">
                                            <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                            <button type="button" className="btn-close float-end close-filter" data-bs-dismiss="advanced-filter" aria-label="Close"></button>
                                        </div>
                                        {renderFilterContent()}
                                    </div>
                                    <div className="d-flex justify-content-end mt-3">
                                        <button className="btn hive-btn-secondary me-2" onClick={handleClearFilters}>Clear</button>
                                        <button className="btn hive-btn-primary" onClick={handleApplyFilters} disabled={isFieldsEmpty() || dateError}>Apply</button>
                                    </div>
                                </div>
                            </div>
                            {renderActionButton()}
                            <button class="btn hive-btn-outline more-indicator-1 float-left cursor-pointer ms-2"
                                onClick={() => handleS3LinkClick(s3Link)}>
                                <img src="/Images/manual.svg" class="me-2" alt="import-icon" />
                            </button>
                            <div class="dropdown-items-1 border border-light mt-2 bg-white rounded-3 p-2 shadow">
                                <div class="d-flex flex-wrap gap-2">
                                    <span class="practices-badge px-2 py-1 rounded-2">Click here to download the user manual</span>
                                </div></div>
                        </div>
                    </div>

                    {/* Tab Content */}
                    <div className="col-md-12">
                        <div className="tab-content" id="pills-tabContent">
                            {/* My Certifications Tab */}
                            <div
                                className={`tab-pane fade mt-4 ${activeTab === 'myCertifications' ? 'show active' : ''}`}
                                id="myCertifications"
                                role="tabpanel"
                                aria-labelledby="myCertificationsTab"
                            >
                                {activeTab === 'myCertifications' && (
                                    <MyCertifications
                                        certificates={certificates}
                                        totalRecords={myCertificationsCount.total}
                                        numberOfRecords={myCertificationsCount.current}
                                        searchTerm={searchTerm}
                                        onSearchChange={setSearchTerm}
                                        hideHeader={true}
                                        filters={employeeFilter}
                                        onFilterChange={handleEmployeeFilterChange}
                                        onClearFilters={handleClearEmployeeFilters}
                                        sortColumn={sortColumn}
                                        sortOrder={sortOrder}
                                        onSortChange={handleSortChange}
                                        showLoadMore={showLoadMore}
                                        onShowMore={handleShowMore}
                                        setSortColumn={setSortColumn}
                                        setSortOrder={setSortOrder}
                                        fetchCertifications={fetchCertifications}
                                    />
                                )}
                            </div>

                            {/* Certification Approvals Tab */}
                            <div
                                className={`tab-pane fade mt-4 ${activeTab === 'certificationApprovals' ? 'show active' : ''}`}
                                id="certificationApprovals"
                                role="tabpanel"
                                aria-labelledby="certificationApprovalsTab"
                            >
                                {activeTab === 'certificationApprovals' && (
                                    <CertificationList
                                        certificates={certificates}
                                        setCertificates={setCertificates}
                                        totalRecords={approvalsCount.total}
                                        numberOfRecords={approvalsCount.current}
                                        searchTerm={searchTerm}
                                        handleSortChange={handleSortChange}
                                        fetchCertifications={fetchCertifications}
                                        sortColumn={sortColumn}
                                        sortOrder={sortOrder}
                                        onShowMore={handleShowMore}
                                        showLoadMore={showLoadMore}
                                    />
                                )}
                            </div>

                            {/* Manage Certifications Tab */}
                            <div
                                className={`tab-pane fade mt-4 ${activeTab === 'manageCertifications' ? 'show active' : ''}`}
                                id="manageCertifications"
                                role="tabpanel"
                                aria-labelledby="manageCertificationsTab"
                            >
                                <div className="mt-4">
                                    <table className="table bg-white hive-grid mb-3 table-borderless">
                                        <thead className="hive-table-head">
                                            <tr>
                                                <th
                                                    onClick={() => handleSortChange("certificate_name")}
                                                    className={`bold-text font-12 ${sortColumn === "certificate_name" ? 'sorted' : ''}`}
                                                >
                                                    Certification Name
                                                    <span className="ps-2">
                                                        <img
                                                            src={DOMPurify.sanitize(getSortIcon("certificate_name"))}
                                                            alt="Sorticon"
                                                            className={`hive-table-sort ${sortColumn === "certificate_name" ? "active-sort" : ""
                                                                }`}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    onClick={() => handleSortChange("provider")}
                                                    className={`bold-text font-12 ${sortColumn === "provider" ? 'sorted' : ''}`}
                                                >
                                                    Provider
                                                    <span className="ps-2">
                                                        <img
                                                            src={DOMPurify.sanitize(getSortIcon("provider"))}
                                                            alt="Sorticon"
                                                            className={`hive-table-sort ${sortColumn === "provider" ? "active-sort" : ""
                                                                }`}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    onClick={() => handleSortChange("cost")}
                                                    className={`bold-text font-12 ${sortColumn === "cost" ? 'sorted' : ''}`}
                                                >
                                                    Cost
                                                    <span className="ps-2">
                                                        <img
                                                            src={DOMPurify.sanitize(getSortIcon("cost"))}
                                                            alt="Sorticon"
                                                            className={`hive-table-sort ${sortColumn === "cost" ? "active-sort" : ""
                                                                }`}
                                                        />
                                                    </span>
                                                </th>
                                                <th
                                                    onClick={() => handleSortChange("practice")}
                                                    className={`bold-text font-12 ${sortColumn === "practice" ? 'sorted' : ''}`}
                                                    style={{ width: '200px' }}
                                                >
                                                    Eligible Practices
                                                    <span className="ps-2">
                                                        <img
                                                            src={DOMPurify.sanitize(getSortIcon("practice"))}
                                                            alt="Sorticon"
                                                            className={`hive-table-sort ${sortColumn === "practice" ? "active-sort" : ""
                                                                }`}
                                                        />
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12">
                                                    Materials Path Link
                                                </th>
                                                <th className='text-center bold-text font-12'>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="hive-table-data regular-text align-middle">
                                                <td>
                                                    <div className="input-group">

                                                        <input
                                                            type="text"
                                                            className={`form-control hive-form-control ${validationErrors.certificateName ? 'is-invalid' : ''}`}
                                                            placeholder="Enter Certification Name"
                                                            value={editFormData.certificateName || ""}
                                                            onChange={(e) => handleInputChange('certificateName', e.target.value)}
                                                        />
                                                        {validationErrors.certificateName && (
                                                            <div className="invalid-feedback">Please enter certification name</div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">

                                                        <input
                                                            type="text"
                                                            className={`form-control hive-form-control ${validationErrors.provider ? 'is-invalid' : ''}`}
                                                            placeholder="Enter Provider Name"
                                                            value={editFormData.provider || ""}
                                                            onChange={(e) => handleInputChange('provider', e.target.value)}
                                                        />
                                                        {validationErrors.provider && (
                                                            <div className="invalid-feedback">Please enter provider</div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="text-end">
                                                    <div className="input-group">

                                                        <span className="input-group-text">$</span>

                                                        <input
                                                            type="text"
                                                            className={`form-control hive-form-control ${validationErrors.cost ? 'is-invalid' : ''}`}
                                                            placeholder="Enter Cost"
                                                            value={editFormData.cost || ""}
                                                            onChange={(e) => {
                                                                if (validateCost(e.target.value)) {
                                                                    handleInputChange('cost', e.target.value);
                                                                }
                                                            }}
                                                        />
                                                        {validationErrors.cost && (
                                                            <div className="invalid-feedback">Please enter a valid cost</div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">

                                                        <PracticeMultiSelect
                                                            value={editFormData.practice}
                                                            onChange={(val) => {
                                                                const newValue = val === "" ? undefined : val.split(',');
                                                                setEditFormData({ ...editFormData, practice: newValue });
                                                                if (validationErrors.practice) {
                                                                    setValidationErrors({ ...validationErrors, practice: false });
                                                                }
                                                            }}
                                                            options={domains}
                                                            isInvalid={validationErrors.practice}
                                                        />
                                                        {validationErrors.practice && (
                                                            <div className="invalid-feedback" style={{ display: 'block' }}>Please select at least one practice</div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className={`form-control hive-form-control ${materialLinkError ? 'is-invalid' : ''}`}
                                                            placeholder="Enter Path Link"
                                                            value={editFormData.materialPath || ""}
                                                            onChange={(e) => handleInputChange('materialPath', e.target.value)}
                                                        />
                                                        {materialLinkError && (
                                                            <div className="invalid-feedback">Please enter a valid URL or leave it empty.</div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <button
                                                        className="bg-transparent border-0 pe-0"
                                                        onClick={() => { handleAddCourse() }}
                                                    >
                                                        <img src="/Images/inline-add-icon.svg" alt="add" />
                                                    </button>
                                                </td>
                                            </tr>
                                            {coursesData.map((course) => (
                                                <tr key={course.certificateId} className='hive-table-data regular-text align-middle'>
                                                    <td>{course.certificateName}</td>
                                                    <td>{course.provider}</td>
                                                    <td className='text-end'>$ {course.cost}</td>
                                                    <td className="position-relative">
                                                        {course.practice && (
                                                            <>
                                                                <span className="float-left">
                                                                    {course.practice.split(',')[0]} {/* Show first practice */}
                                                                </span>
                                                                {course.practice.split(',').length > 1 && (
                                                                    <>
                                                                        <span className="more-indicator float-left cursor-pointer ms-2">
                                                                            +{course.practice.split(',').length - 1}
                                                                        </span>
                                                                        <div className="dropdown-items border border-light mt-2 bg-white rounded-3 p-2 shadow">
                                                                            <div className="d-flex flex-wrap gap-2">
                                                                                {course.practice.split(',').map((practice, index) => (
                                                                                    <span key={index} className="practices-badge px-2 py-1 rounded-2">
                                                                                        {practice.trim()}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </>
                                                        )}
                                                    </td>
                                                    <td style={{
                                                        maxWidth: "200px",
                                                        wordBreak: "break-all",
                                                        whiteSpace: "normal",
                                                    }}>
                                                        <a
                                                            href={DOMPurify.sanitize(course.materialPath)}
                                                            target="_blank"
                                                            rel='noopener noreferrer'
                                                            className='text-decoration-none table-name-style'
                                                            title={course.materialPath}
                                                            style={{
                                                                display: "inline-block",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                maxWidth: "100%",
                                                                verticalAlign: "middle"
                                                            }}
                                                        >
                                                            {course.materialPath
                                                                .replace(/^https?:\/\/(www\.)?/, '') // Remove http(s):// and optional www.
                                                                .substring(0, 30)} {/* Show first 30 characters */}
                                                            {course.materialPath.length > 30 && '...'} {/* Add ellipsis if truncated */}
                                                        </a>
                                                    </td>
                                                    <td className='text-center'>
                                                        <button
                                                            className="bg-transparent border-0 pe-0"
                                                            onClick={() => handleEditClick(course)}
                                                        >
                                                            <img src='/Images/edit-action.svg' alt='edit' />
                                                        </button>
                                                        <button
                                                            className="bg-transparent border-0"
                                                            onClick={() => handleDeleteClick(course.certificateId, course.certificateName)}
                                                        >
                                                            <img src='/Images/delete-action.svg' alt='delete' />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    {/* Pagination */}
                                    <p className='font-12 pagination'>
                                        Showing<span className='bold-text mx-1'>{manageCertificationsCount.current}</span> of
                                        <span className='bold-text mx-1'>{manageCertificationsCount.total}</span> Records
                                    </p>

                                    {showLoadMore() && (
                                        <div className='text-center'>
                                            <button className='btn show-more-btn' onClick={handleShowMore}>Show More</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CourseDeletePopup
                    show={showDeletePopup}
                    onClose={() => setShowDeletePopup(false)}
                    onConfirm={handleConfirmDelete}
                    certificateName={certificateNameToDelete}
                />


                {showImportPopup && (
                    <CourseImportPopup onUpload={handleUpload} onClose={() => setShowImportPopup(false)} />
                )}

                {showApplyPopup && (
                    <ApplyCertificationPopup
                        show={showApplyPopup}
                        onClose={() => setshowApplyPopup(false)}
                        onSubmit={handleSubmitApplication}
                        employeeId={empId}
                        employeeName={employeeName}
                        domain={empDomain}
                        courses
                        completedCertifications={completedCertifications}
                        allowedCertifications={allowedCertifications}
                        appliedCertificates={certificates?.filter(cert => cert?.initial_ph_approval?.String !== "Rejected")?.map(cert => cert.certificate_id)}
                    />
                )}
                <Toaster />

            </div>
        </div>

    );
};

export default AdminCertifications;
